// @limit - number of classrooms requested by page.
export const classroomsPagination = {
  limit: 12,
}
